function HomePage() {
    return (
        <section className="main-menu">
            <h1>Welcome to memory !</h1>
        </section>
    );
}

export default HomePage;